import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapImage, BootstrapLink } from '../../../dsl/front';
import { Source } from './ArticleSource.contracts';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const PAP = require('@client-assets/images/logotypes/pap.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const MSPO = require('@client-assets/images/logotypes/mspo.svg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Militarnyi = require('@client-assets/images/logotypes/militarnyi.svg');
const sourceMap = {
    [Source.PAP]: {
        image: {
            src: PAP,
            alt: 'PAP',
            width: 42,
            height: 26
        },
        url: 'https://www.pap.pl/',
        newTab: true,
        useSite: false
    },
    [Source.PAPnD24]: {
        image: {
            src: PAP,
            alt: 'PAP',
            width: 42,
            height: 26
        },
        url: 'https://www.pap.pl/',
        newTab: true,
        useSite: true
    },
    [Source.MSPO]: {
        image: {
            src: MSPO,
            alt: 'MSPO',
            width: 347,
            height: 80
        },
        newTab: false,
        useSite: true
    },
    [Source.Militarnyi]: {
        image: {
            src: Militarnyi,
            alt: 'Militarnyi',
            width: 80,
            height: 80
        },
        url: 'https://militarnyi.com/',
        newTab: true,
        useSite: false
    }
};
let ArticleSource = class ArticleSource extends Vue {
    get sourceDetails() {
        var _a;
        return (_a = sourceMap[this.source]) !== null && _a !== void 0 ? _a : null;
    }
};
__decorate([
    Prop({ type: String, required: true })
], ArticleSource.prototype, "source", void 0);
__decorate([
    Prop({ type: String, required: true })
], ArticleSource.prototype, "siteName", void 0);
ArticleSource = __decorate([
    Component({
        name: 'ArticleSource',
        components: { BootstrapImage, BootstrapLink },
        template: `
    <div class="article-source">
      <span class="article-source__label">{{ $t('modules.ArticleSource.sourceLabel') }}:</span>

      <template v-if="sourceDetails">
        <BootstrapLink :link="{ target: { path: sourceDetails.url }, newTab: sourceDetails.newTab  }">
          <BootstrapImage v-if="sourceDetails.image" v-bind="sourceDetails.image" class="article-source__image"/>
        </BootstrapLink>
        <template v-if="sourceDetails.useSite">
          / {{ siteName }}
        </template>
      </template>
      <template v-else>
        {{ source }}
      </template>
    </div>
  `
    })
], ArticleSource);
export { ArticleSource };
